import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { SortDirection } from "./Types.fs.js";

export class Column {
    constructor() {
    }
}

export function Column$reflection() {
    return class_type("Feliz.TanStack.Table.Sorting.Column", void 0, Column);
}

export function Column_getAutoSortingFn_Z2685F962(column) {
    return column.getAutoSortingFn();
}

export function Column_getAutoSortDir_Z2685F962(column) {
    const dir = column.getAutoSortDir();
    switch (dir) {
        case "asc": {
            return new SortDirection(0);
        }
        case "desc": {
            return new SortDirection(1);
        }
        default: {
            return new SortDirection(2);
        }
    }
}

export function Column_getSortingFn_Z2685F962(column) {
    return column.getSortingFn();
}

export function Column_getNextSortingOrder_Z2685F962(column) {
    const matchValue = column.getNextSortingOrder();
    switch (matchValue) {
        case "asc": {
            return new SortDirection(0);
        }
        case "desc": {
            return new SortDirection(1);
        }
        default: {
            return new SortDirection(2);
        }
    }
}

export function Column_getCanSort_Z2685F962(column) {
    return column.getCanSort();
}

export function Column_getSortIndex_Z2685F962(column) {
    return column.getSortIndex();
}

export function Column_getIsSorted_Z2685F962(column) {
    const isSorted = column.getIsSorted();
    switch (isSorted) {
        case "asc": {
            return new SortDirection(0);
        }
        case "desc": {
            return new SortDirection(1);
        }
        default: {
            return new SortDirection(2);
        }
    }
}

export function Column_clearSorting_Z2685F962(column) {
    column.clearSorting();
}

export function Column_getCanMultiSort_Z2685F962(column) {
    return column.getCanMultiSort();
}

export function Column_toggleSorting_Z2685F962(column) {
    if (Column_getCanSort_Z2685F962(column)) {
        column.toggleSorting(null, false);
    }
}

export function Column_toggleSorting_ZD093290(column, event) {
    if (Column_getCanSort_Z2685F962(column)) {
        const canMultiSort = Column_getCanMultiSort_Z2685F962(column);
        const isMultiSortEvent = event.shiftKey;
        column.toggleSorting(null, (canMultiSort && isMultiSortEvent));
    }
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Sorting.Table", void 0, Table);
}

export function Table_setSorting(sortingState, table) {
    return table._obj.setSorting(sortingState);
}

export function Table_resetSorting(defaultState, table) {
    table._obj.resetSorting(defaultState);
    return table;
}

export function Table_getPreSortedRowModel_Z4395D14A(table) {
    return table._obj.getPreSortedRowModel();
}

export function Table_getSortedRowModel_Z4395D14A(table) {
    return table._obj.getSortedRowModel();
}

//# sourceMappingURL=Sorting.fs.js.map
